export default "__VITE_ASSET__DcsEtEnS__"